import { connect } from 'react-redux';
import property from 'lodash/fp/property';
import RankingParticipants from './RankingParticipants';
import { selectRankingDetails } from '@selectors/ranking';
import { isWordCupStarted } from '@selectors/clock';

import { saveRanking } from '../../service/ranking';

export const removeParticipant = _id => (dispatch, getState) => {
  let { jwToken, rankingDetails } = getState();

  let participants = rankingDetails.participants
    .filter(p => p._id !== _id)
    .map(property('_id'));

  dispatch({ type: 'RANKING_PARTICIPANTS_SAVING', payload: true });
  return saveRanking(jwToken, rankingDetails._id, { participants }).then(
    res => {
      dispatch({
        type: 'RANKING_DETAILS_SET',
        payload: res.data
      });

      dispatch({ type: 'RANKING_PARTICIPANTS_CLEAR' });
    }
  );
};

export const mapStateToProps = state => ({
  ...selectRankingDetails(state),
  isWordCupStarted: isWordCupStarted(state)
});

export const mapDispatchToProps = dispatch => ({
  onRemove: _id => dispatch(removeParticipant(_id))
});

export default connect(mapStateToProps, mapDispatchToProps)(
  RankingParticipants
);
